"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModuleBase = _interopRequireDefault(require("../Module/ModuleBase"));

var _ModuleMedia = _interopRequireDefault(require("../Module/ModuleMedia"));

var _ModuleTitle = _interopRequireDefault(require("../Module/ModuleTitle"));

var _ModuleLabel = _interopRequireDefault(require("../Module/ModuleLabel"));

var _ModuleDescription = _interopRequireDefault(require("../Module/ModuleDescription"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& + $root": {
      marginTop: theme.spacing(.5)
    },
    "&:hover": {
      cursor: "pointer",
      boxShadow: theme.shadows[4]
    }
  },
  small: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  body: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "100%",
    flexBasis: "100%",
    overflow: "hidden",
    zIndex: 1,
    margin: theme.spacing(1)
  },
  media: {
    display: "flex"
  },
  content: {
    width: "100%",
    maxWidth: "100%",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  header: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  },
  footer: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "flex-start",
    "& > * + *": {
      marginLeft: theme.spacing(.5)
    }
  }
}));

const InboxAttachment = ({
  size = "medium",
  imageUrl,
  title,
  description,
  label,
  documentType,
  uniqueId,
  commentCount,
  onClick
}) => {
  const classes = useStyles();
  let metadata = [];

  if (uniqueId) {
    metadata.push('#' + uniqueId);
  }

  if (commentCount) {
    metadata.push(commentCount + " comments");
  }

  if (description) {
    metadata.push(description);
  }

  description = metadata.join(' – ');

  if (size === "small") {
    return _react.default.createElement(_ModuleBase.default, {
      elevation: 1,
      className: classes.root,
      onClick: onClick
    }, _react.default.createElement("div", {
      className: classes.small
    }, _react.default.createElement(_ModuleMedia.default, {
      imageUrl: imageUrl,
      width: "36px",
      height: "36px"
    }), _react.default.createElement("header", {
      className: classes.header
    }, _react.default.createElement(_ModuleLabel.default, {
      className: classes.label,
      label: label || documentType
    }), _react.default.createElement(_ModuleDescription.default, {
      description: description
    }))));
  }

  return _react.default.createElement(_ModuleBase.default, {
    elevation: 1,
    className: classes.root,
    onClick: onClick
  }, _react.default.createElement("div", {
    className: classes.body
  }, _react.default.createElement("div", {
    className: classes.media
  }, _react.default.createElement(_ModuleMedia.default, {
    imageUrl: imageUrl,
    width: "48px",
    height: "48px"
  })), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_ModuleTitle.default, {
    title: title
  })), _react.default.createElement("footer", {
    className: classes.footer
  }, _react.default.createElement(_ModuleLabel.default, {
    label: label || documentType
  }), _react.default.createElement(_ModuleDescription.default, {
    description: description
  })))));
};

InboxAttachment.propTypes = process.env.NODE_ENV !== "production" ? {
  imageUrl: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  label: _propTypes.default.string,
  status: _propTypes.default.string,
  author: _propTypes.default.string,
  datetime: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onEdit: _propTypes.default.func
} : {};
var _default = InboxAttachment;
exports.default = _default;
module.exports = exports.default;